import React, { Component } from "react";
import {
    Button
} from "reactstrap";
import { Formik, Field, Form, ErrorMessage } from "formik";
import moment from "moment";
import { connect } from "react-redux";
import style from "./MediclaimProcess.module.css";
import {
    submitClaim,
    checkMSVDetails,
    linkDestinationCodes,
    fetchRelatedParty,
    fetchMedSchemes,
    fetchMedSchemesPlan,
    fetchMedSchemesPlanOptions,
    fetchMedSchemesPlanSubOptions
} from "../../../../redux";
import ttmLoader from "../../../../assets/images/ttm-loader.gif";
import { checkIfPermitted, Permissions } from "../../../../services/RolePermissionService";
import * as Yup from "yup";
import { DatePicker } from "antd";
import { Select } from "antd";
import MSVDetailsSection from "../../../../containers/MSVDetailsSections";
import { isEmpty } from "../../../../utils/CommonUtil";
const { Option } = Select;

function dateFormatter(cell) {
    if (!cell) {
        return "";
    }
    return `${
        moment(cell).format("YYYY-MM-DD")
            ? moment(cell).format("YYYY-MM-DD")
            : moment(cell).format("YYYY-MM-DD")
        }`;
}

export class MediclaimProcess extends Component {
    constructor(props) {
        super(props);
        this.state = {
            msvSectionEnable: true,
            continueToClaimSectionEnable: false,
            continueToClaimMessage: "",
            msvCheckLoader: false,
            msvAllowed: "",
            member_full_name: "",
            member_surname: "",
            medical_scheme_code: "",
            medical_scheme_plan: "",
            membership_number: "",
            medical_scheme_plan_option: "",
            medical_scheme_plan_suboption: "",
            memberIDPassportNumber: "",

            patient_full_name: "",
            patient_surname: "",
            patient_initials: "",
            dateOfBirth: "",
            gender: "",
            patient_height: "",
            patient_weight: "",
            patientIDPassportNumber: "",
            dependent_code: "",
            patient_id: "",
            invoice_id: "",
            isScreenLoaded: false,
            destinationCodeData: {},
            errorMessage: "",
            resubmission_code: "",
            submitClaimLoader: false
        };
    }

    componentDidMount = async () => {
        document.title = 'Claim Details - TechToMedix';
        //console.log("props", this.props)

        await this.props.fetchMedSchemes(this.state.medical_scheme_code);
        if (this.props.location && this.props.location.state && this.props.location.state.related_party) {
            if(this.props.location.state.resubmission_code){
                this.setState({
                    resubmission_code: this.props.location.state.resubmission_code
                })
            }
            await this.props.linkDestinationCodes(this.props.location.state.related_party);

            if (!this.props.linkDestinationCodeData.loading && this.props.linkDestinationCodeData.linkDestinationCodes) {
                this.setState({
                    invoice_id:  this.props.location.state && this.props.location.state.invoice_id,
                    destinationCodeData: this.props.linkDestinationCodeData.linkDestinationCodes,
                    msvSectionEnable: this.props.linkDestinationCodeData.linkDestinationCodes.msv_allowed === "Y",
                    continueToClaimSectionEnable: this.props.linkDestinationCodeData.linkDestinationCodes.msv_allowed === "N",
                    continueToClaimMessage: this.props.linkDestinationCodeData.linkDestinationCodes.msv_allowed === "N" ? "MSV is not allowed on this patient." : ""
                })
            }
        }


        setTimeout(() => {
            this.setState({
                isScreenLoaded: true,
            });
        }, 500);
    }

    callPatientDetailsAPI = async () => {

        await this.props.fetchRelatedParty(this.props.location.state.related_party);
        if (!this.props.patientData.loading) {
            let patientData = this.props.patientData.relatedPartyData && this.props.patientData.relatedPartyData.relatedPartyDetails;

            if (patientData) {
                this.setState({
                    patient_id: this.props.location.state.related_party,
                    invoice_id: this.props.location.state.invoice_id,
                    member_full_name: patientData.member_fullname ? patientData.member_fullname : "",
                    member_surname: patientData.member_surname ? patientData.member_surname : "",
                    medical_scheme_code: patientData.scheme_code,
                    medical_scheme_plan: patientData.scheme_plan_code,
                    membership_number: patientData.membership_number,
                    medical_scheme_plan_option: patientData.scheme_plan_option_code,
                    medical_scheme_plan_suboption: patientData.scheme_plansuboption_code,
                    memberIDPassportNumber: patientData.membership_passport_number,

                    patient_full_name: patientData.name + " " + patientData.surname,
                    patient_surname: patientData.surname,
                    patient_initials: patientData.initials ? patientData.initials : "",
                    dateOfBirth: moment(patientData.dob).format("YYYY-MM-DD"),
                    gender: patientData.gender,
                    patient_height: patientData.height ? patientData.height : "",
                    patient_weight: patientData.weight ? patientData.weight : "",
                    patientIDPassportNumber: patientData.passport_number,
                    dependent_code: patientData.dependant_code ? patientData.dependant_code : "",
                    errorMessage: ""
                }, () => {
                    this.getAllSchemesData();
                })

            }

        }

    }

    callMSVCheckAPI = async () => {

        this.setState({
            msvCheckLoader: true,
        })
        await this.props.checkMSVDetails(this.props.location.state.related_party, this.props.location.state.requested_professional);
        if (!this.props.checkMSVDetailsData.loading) {
            console.log("error",this.props.checkMSVDetailsData.error)
            if(this.props.checkMSVDetailsData.error){
                this.setState({ 
                    msvCheckLoader: false,
                    errorMessage: this.props.checkMSVDetailsData.error
                })
            }

            let patientData = this.props.checkMSVDetailsData && this.props.checkMSVDetailsData.checkMSVDetails;
            console.log("patientData",patientData)
            if (!isEmpty(patientData) || patientData.length > 0) {
                this.setState({
                    // patient_id: this.props.location.state.related_party,
                    // invoice_id: this.props.location.state.invoice_id,
                    // member_full_name: patientData.member_fullname ? patientData.member_fullname : "",
                    // member_surname: patientData.member_surname ? patientData.member_surname : "",
                    // medical_scheme_code: patientData.scheme_code,
                    // medical_scheme_plan: patientData.scheme_plan_code,
                    // membership_number: patientData.membership_number,
                    // medical_scheme_plan_option: patientData.scheme_plan_option_code,
                    // medical_scheme_plan_suboption: patientData.scheme_plansuboption_code,
                    // memberIDPassportNumber: patientData.passport_number,

                    // patient_full_name: patientData.patient_name,
                    // patient_surname: patientData.patient_surname,
                    // patient_initials: patientData.patient_initials ? patientData.patient_initials : "",
                    // dateOfBirth: moment(patientData.dob).format("YYYY-MM-DD"),
                    // gender: patientData.gender,
                    // patient_height: patientData.height ? patientData.height : "",
                    // patient_weight: patientData.weight ? patientData.weight : "",
                    // patientIDPassportNumber: patientData.passport_number,
                    // dependent_code: patientData.patient_dependant_code ? patientData.patient_dependant_code : "",
                 // continueToClaimSectionEnable: patientData.result_status && patientData.result_status === "Invalid" ? true : false,
                    msvData : patientData,   
                 continueToClaimSectionEnable:  true,
                    continueToClaimMessage: patientData.result_status && patientData.result_status === "Invalid" ? "Your membership is invalid." : "",
                    msvCheckLoader: false,
                    msvSectionEnable: false,
                    errorMessage: ""
                }, () => {
                   // this.callPatientDetailsAPI();
                    //this.getAllSchemesData();
                })

            }

        }

    }

    getAllSchemesData = () => {
        if (this.state.medical_scheme_code) {
            this.props.fetchMedSchemesPlan(this.state.medical_scheme_code);
        }

        if (this.state.medical_scheme_plan) {
            this.props.fetchMedSchemesPlanOptions(this.state.medical_scheme_plan);
        }

        if (this.state.medical_scheme_plan_option) {
            this.props.fetchMedSchemesPlanSubOptions(this.state.medical_scheme_plan_option);
        }
    }


    handleInputChange = (event) => {
        const val = event.target.value;
        const name = event.target.name;
        this.setState({
            [name]: val,
        });

        if (name === "medical_scheme_code" && val) {
            console.log("med scheme selected");
            if (this.state.medical_scheme_plan) {
                this.setState({
                    medical_scheme_plan: "",
                });
            }
            if (this.state.medical_scheme_plan_option) {
                this.setState({
                    medical_scheme_plan_option: "",
                });
            }
            if (this.state.medical_scheme_plan_suboption) {
                this.setState({
                    medical_scheme_plan_suboption: "",
                });
            }
            this.props.fetchMedSchemesPlan(val);
        }

        if (name === "medical_scheme_plan" && val) {
            console.log("med scheme Plan selected");

            if (this.state.medical_scheme_plan_option) {
                this.setState({
                    medical_scheme_plan_option: "",
                });
            }
            if (this.state.medical_scheme_plan_suboption) {
                this.setState({
                    medical_scheme_plan_suboption: "",
                });
            }
            this.props.fetchMedSchemesPlanOptions(val);
        }

        if (name === "medical_scheme_plan_option" && val) {
            console.log("med scheme Plan option selected");

            if (this.state.medical_scheme_plan_suboption) {
                this.setState({
                    medical_scheme_plan_suboption: "",
                });
            }
            this.props.fetchMedSchemesPlanSubOptions(val);
        }
    };

    handleInputDateChange = (date) => {
        this.setState({
            dateOfBirth: date
        })
    }

    performMSVCheck = (flag) => {
        // console.log("flag", flag)
        if (flag === "yes") {
            if (this.state.destinationCodeData &&
                this.state.destinationCodeData.msv_allowed === "Y") {
                this.callMSVCheckAPI();
            }
        } else {
            this.setState({
                msvSectionEnable: false
            }, () => {
                this.callPatientDetailsAPI();
            })
        }

    }

    continueClaim = (flag) => {
        if (flag === "yes") {
            this.setState({
                msvSectionEnable: false,
                continueToClaimSectionEnable: false
            }, () => {
                this.callPatientDetailsAPI();
            })
        } else {
            this.props.history.push({
                pathname: "/app/createinvoice/" + this.state.invoice_id
            });
        }
    }

    // membershipInvalidContinue = (flag) => {
    //     if (flag === "yes") {
    //         this.setState({
    //             msvSectionEnable: false
    //         }, () => {
    //             // this.callPatientDetailsAPI();
    //         })
    //     } else {
    //         history.goBack();
    //     }
    // }

    onSubmit = async () => {
        this.setState({
            submitClaimLoader: true
        })
        const schemesDropDownListData = this.props.schemesData.schemes;
        const schemesPlanDropDownListData = this.props.schemesPlanData.schemesPlan;

        const medical_scheme = schemesDropDownListData &&
            schemesDropDownListData.find((element, index) => (
                element.code === this.state.medical_scheme_code
            ));


        const medical_scheme_plan = schemesPlanDropDownListData &&
            schemesPlanDropDownListData.find((element, index) => (
                element.code === this.state.medical_scheme_plan
            ));

        const payload = {
            invoice_id: this.state.invoice_id,
            member_fullname: this.state.member_full_name,
            member_surname: this.state.member_surname,
            scheme_code: this.state.medical_scheme_code,
            scheme_plan_code: this.state.medical_scheme_plan,
            scheme_plan_option_code: this.state.medical_scheme_plan_option,
            membership_passport_number: this.state.memberIDPassportNumber,
            fullname: this.state.patient_full_name,
            surname: this.state.patient_surname,
            initials: this.state.patient_initials,
            dob: dateFormatter(this.state.dateOfBirth),
            gender: this.state.gender,
            height: this.state.patient_height,
            weight: this.state.patient_weight,
            passport_number: this.state.patientIDPassportNumber,
            dependant_code: this.state.dependent_code,
            membership_number: this.state.membership_number,
            medical_scheme_name: medical_scheme && medical_scheme.name,
            medical_scheme_plan_name: medical_scheme_plan && medical_scheme_plan.name
        }

        if(this.state.resubmission_code){
            payload.resubmission_code = this.state.resubmission_code
        }


        await this.props.submitClaim(payload);

        //console.log("response", this.props.submitClaimData)

        if (!this.props.submitClaimData.loading) {
            if (!this.props.submitClaimData.errorMessage) {
                this.setState({
                    successMessage: this.props.submitClaimData.successMessage,
                    submitClaimLoader: false,
                    errorMessage: ""
                })

                setTimeout(() => {
                    this.setState({
                        successMessage: "",
                    })

                    this.props.history.push({
                        pathname: "/app/invoicelist"
                    });
                }, 2000);
            } else {
                this.setState({
                    errorMessage: this.props.submitClaimData.errorMessage,
                    successMessage: "",
                    submitClaimLoader: false
                })

                setTimeout(() => {
                    this.setState({
                        errorMessage: ""
                    })
                }, 2000);

            }
        }

    }

    onChangeSchemePlan = (value) => {
        // console.log(`selected ${value}`);
        this.setState({
            medical_scheme_plan: value,
            medical_scheme_code: value,
        });
    };

    saveMSVData = () => {
        let patientData =  this.props.checkMSVDetailsData && 
        this.props.checkMSVDetailsData.checkMSVDetails;

        if(patientData){
            this.setState({
                
               // patient_id: this.props.location.state.related_party,
                //invoice_id: this.props.location.state.invoice_id,
               // member_full_name: patientData.member_fullname ? patientData.member_fullname : this.state.member_full_name,
               // member_surname: patientData.member_surname ? patientData.member_surname : this.state.member_surname,
               /// medical_scheme_code: patientData.scheme_code,
                //medical_scheme_plan: patientData.scheme_plan_code,
               /// membership_number: patientData.membership_number,
               // medical_scheme_plan_option: patientData.scheme_plan_option_code,
               // medical_scheme_plan_suboption: patientData.scheme_plansuboption_code,
                memberIDPassportNumber: patientData.membership_passport_number,

                patient_full_name: patientData.patient_name?patientData.patient_name:this.state.patient_full_name ,
                patient_surname: patientData.patient_surname?patientData.patient_surname: this.state.patient_surname,
                patient_initials: patientData.patient_initials ? patientData.patient_initials : this.state.patient_initials,
                //dateOfBirth: moment(patientData.dob).format("YYYY-MM-DD"),
                //gender: patientData.gender,
               // patient_height: patientData.height ? patientData.height : "",
                //patient_weight: patientData.weight ? patientData.weight : "",
                patientIDPassportNumber: patientData.passport_number? patientData.passport_number: this.state.patientIDPassportNumber,
                dependent_code: patientData.patient_dependant_code ? patientData.patient_dependant_code : this.state.dependent_code,
                errorMessage: ""
            })
        }

    }


    render() {

        if (!this.state.isScreenLoaded) {
            return (
                <div className="dashboard-loader">
                    <img src={ttmLoader} alt="loader" className="loader-image" />
                </div>
            );
        }
        //console.log("stat", this.state)
        const schemesDropDownListData = this.props.schemesData.schemes;
        const schemesPlanDropDownListData = this.props.schemesPlanData.schemesPlan;
        const schemesPlanOptionsDropDownListData = this.props.schemesPlanOptionsData.schemesPlanOptions;
        const schemesPlanSubOptionsDropDownListData = this.props.schemesPlanSubOptionsData.schemesPlanSubOptions;

        const mediaclAidSchemeOptions = schemesDropDownListData &&
            schemesDropDownListData.map((element, index) => (
                <option key={index} value={element.code}>
                    {element.name} ({element.code})
                </option>
            ));


        const mediaclAidSchemePlanOptions = schemesPlanDropDownListData &&
            schemesPlanDropDownListData.map((element, index) => (
                <option key={index} value={element.code}>
                    {element.name} ({element.code})
                </option>
            ));


        const mediaclAidSchemePlanOptionsOptions = schemesPlanOptionsDropDownListData &&
            schemesPlanOptionsDropDownListData.map((element, index) => (
                <option key={index} value={element.code}>
                    {element.name} ({element.code})
                </option>
            ));
        const mediaclAidSchemePlanSubOptionsOptions = schemesPlanSubOptionsDropDownListData &&
            schemesPlanSubOptionsDropDownListData.map((element, index) => (
                <option key={index} value={element.code}>
                    {element.name} ({element.code})
                </option>
            ));
        return (
            <div className={`${style.mediclaimProcessWrapper}`}>
                <div className="row">
                    <div className="col-lg-12">
                        <h3>Claim Process</h3>
                    </div>
                </div>
                {/* <div className="row">
          <div className="col-lg-12 intro-text">
            <p>
              This is the list of all the invoices generated on the system. The
              view action will take you to the invoice preview page.
            </p>
          </div>
        </div> */}
                <div className="row">
                    <div className="col-md-12">
                        {this.state.msvSectionEnable && (
                            <div className="form-box-shadow mt-4">
                                <div className={`row ${style.mediclaimProcessMSVWrapper}`}>
                                    <div className="col-md-12">
                                        <h5 className="">Member Status Validation (MSV) Check</h5>
                                    </div>
                                    <div className="col-md-12">
                                        <label>Do you want to conduct an MSV check on the patient?</label>
                                    </div>
                                    <div className="col-md-12">
                                        <div>
                                            <Button
                                                className="ttm-primary-btn mr-3"
                                                type="button"
                                                onClick={() => this.performMSVCheck("yes")}
                                            >
                                                Yes
                                                </Button>

                                            <Button
                                                className="ttm-primary-btn mr-3"
                                                type="button"
                                                onClick={() => this.performMSVCheck("no")}
                                            >
                                                No
                                        </Button>
                                        </div>
                                        {this.state.msvCheckLoader && (
                                            <div className="col-md-12">
                                                <div className={`error ${style.loadingWrapper}`}>
                                                    <img src={ttmLoader} alt="loader" className={style.loading} />
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    {/* {this.state.destinationCodeData &&
                                        this.state.destinationCodeData.msv_allowed === "N" && this.state.msvSectionEnable && (
                                            <React.Fragment>
                                                <div className="col-md-12">
                                                    <label>MSV is not allowed on this patient. Do you want to continue with the claiming?</label>
                                                </div>
                                                <div className="col-md-12">
                                                    <div>
                                                        <Button
                                                            className="ttm-primary-btn mr-3"
                                                            type="button"
                                                            onClick={() => this.continueClaim("yes")}
                                                        >
                                                            Yes
                                                   </Button>

                                                        <Button
                                                            className="ttm-primary-btn mr-3"
                                                            type="button"
                                                            onClick={() => this.continueClaim("no")}
                                                        >
                                                            No
                                                   </Button>
                                                    </div>
                                                </div>
                                            </React.Fragment>
                                        )} */}


                                    {/* {this.props.checkMSVDetailsData &&
                                        this.props.checkMSVDetailsData.checkMSVDetails &&
                                        this.props.checkMSVDetailsData.checkMSVDetails.result_status === "Invalid" && (
                                            <React.Fragment>
                                                <div className="col-md-12 mt-4">
                                                    <label>Your membership is invalid. Do you want to continue with the claiming?</label>
                                                </div>
                                                <div className="col-md-12">
                                                    <div>
                                                        <Button
                                                            className="ttm-primary-btn mr-3"
                                                            type="button"
                                                            onClick={this.membershipInvalidContinue("yes")}
                                                        >
                                                            Yes
                                                </Button>

                                                        <Button
                                                            className="ttm-primary-btn mr-3"
                                                            type="button"
                                                            onClick={this.membershipInvalidContinue("no")}
                                                        >
                                                            No
                                        </Button>
                                                    </div>
                                                </div>
                                            </React.Fragment>
                                        )} */}
                                </div>

                            </div>)}
                            {this.state.errorMessage && (
                                <p className={style.errorMessage}>{this.state.errorMessage}</p>
                            )}
                        {this.state.continueToClaimSectionEnable && (
                            <div className="form-box-shadow mt-4">
                                <div className={`row ${style.mediclaimProcessMSVWrapper}`}>
                                    {/* <div className="col-md-12">
                                        <h5 className="">Member Status Validation (MSV) Check</h5>
                                    </div> */}

                                    <div className="col-md-12">
                                        <label>{this.state.continueToClaimMessage} Do you want to continue with the claiming?</label>
                                    </div>
                                    <div className="col-md-12">
                                        <div>
                                            <Button
                                                className="ttm-primary-btn mr-3"
                                                type="button"
                                                onClick={()=>this.continueClaim("yes")}
                                            >
                                                Yes
                                                </Button>

                                            <Button
                                                className="ttm-primary-btn mr-3"
                                                type="button"
                                                onClick={()=>this.continueClaim("no")}
                                            >
                                                No
                                        </Button>
                                        </div>
                                    </div>
                                </div>

                            </div>)}

                        {this.state.msvData &&
                            this.state.msvData.result_status && (

                                <div className="mt-3">
                                    <MSVDetailsSection 
                                    data={this.state.msvData}
                                    saveMSVData={this.saveMSVData} 
                                    claimProcess={!this.state.msvSectionEnable && !this.state.continueToClaimSectionEnable}
                                     />

                                </div>)}

                        <Formik
                            initialValues={this.state}
                            enableReinitialize={true}
                            validationSchema={Yup.object().shape({
                                member_full_name: Yup.string()
                                .trim()
                                .matches(/^[a-zA-Z ]*$/, "Enter alphabets only")
                                .required("Full Name is required"),
                                member_surname: Yup.string()
                                .trim()
                                .matches(/^[a-zA-Z ]*$/, "Enter alphabets only")
                                .required("Last Name is required"),
                                medical_scheme_code: Yup.string()
                                .required("Scheme Name is required"),
                                medical_scheme_plan: Yup.string()
                                .required("Scheme Plan is required"),
                                membership_number: Yup.string()
                                .trim().required("Membership Number is required")
                                .matches(/^[a-zA-Z0-9 ]*$/, "Only alphanumeric values allowed"),
                                //medical_scheme_plan_option: Yup.string().required("Scheme Plan Option is required"),
                                // medical_scheme_plan_suboption: Yup.string().required("Scheme Plan Option is required"),
                                memberIDPassportNumber: Yup.string()
                                .trim().required("ID/Passport Number is required")
                                .matches(/^[a-zA-Z0-9 ]*$/, "Only alphanumeric values allowed"),
                                patient_full_name: Yup.string()
                                .trim().required("Full Name is required")
                                .matches(/^[a-zA-Z ]*$/, "Enter alphabets only"),
                                patient_surname: Yup.string().trim()
                                .required("Surname is required")
                                .matches(/^[a-zA-Z ]*$/, "Enter alphabets only"),
                                patient_initials: Yup.string().trim()
                                .required("Initials are required"),
                                dateOfBirth: Yup.string()
                                .required("Date of Birth is required"),
                                gender: Yup.string()
                                .required("Gender is required"),
                                patient_height: Yup.string()
                                .matches(/^[0-9]*$/, "Enter numbers only"),
                                patient_weight: Yup.string()
                                .matches(/^[0-9]*$/, "Enter numbers only"),
                                patientIDPassportNumber: Yup.string().trim()
                                .required("ID/Passport Number is required")
                                .matches(/^[a-zA-Z0-9 ]*$/, "Only alphanumeric values allowed"),
                                dependent_code: Yup.string().trim()
                                    .matches(/^[0-9]*$/, "Enter numbers only")
                                    .required("Dependent code is required")
                            })}
                            onSubmit={this.onSubmit}
                        >
                            {({ errors, status, touched }) => (
                                <div>

                                    {!this.state.msvSectionEnable && !this.state.continueToClaimSectionEnable && (
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className={style.mediclaimProcessMSVWrapper}>
                                                    <Form>
                                                        <div className="form-box-shadow mt-4">
                                                            <div className="row">
                                                                <div className="col-lg-12">
                                                                    <h5>Membership Information</h5>
                                                                </div>
                                                            </div>

                                                            <div className="row">
                                                                <div className="col-md-6 col-lg-4 col-xl-3">
                                                                    <div className="form-group">
                                                                        <label htmlFor="member_full_name">
                                                                            Member Full Name
                                                                        <span className="mandatory">*</span>
                                                                        </label>

                                                                        <Field
                                                                            name="member_full_name"
                                                                            type="text"
                                                                            maxLength="30"
                                                                            placeholder="Medical Full Name"
                                                                            className={
                                                                                "form-control" +
                                                                                (errors.member_full_name && touched.member_full_name
                                                                                    ? " is-invalid"
                                                                                    : "")
                                                                            }
                                                                            onChange={this.handleInputChange}
                                                                        />
                                                                        <ErrorMessage
                                                                            name="member_full_name"
                                                                            component="div"
                                                                            className="invalid-feedback"
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6 col-lg-4 col-xl-3">
                                                                    <div className="form-group">
                                                                        <label htmlFor="member_surname">Member Surname
                                                                        <span className="mandatory">*</span>
                                                                        </label>

                                                                        <Field
                                                                            name="member_surname"
                                                                            maxLength="30"
                                                                            placeholder="Medical Surname"
                                                                            type="text"
                                                                            className={
                                                                                "form-control" +
                                                                                (errors.member_surname && touched.member_surname
                                                                                    ? " is-invalid"
                                                                                    : "")
                                                                            }
                                                                            onChange={this.handleInputChange}
                                                                        />
                                                                        <ErrorMessage
                                                                            name="member_surname"
                                                                            component="div"
                                                                            className="invalid-feedback"
                                                                        />
                                                                    </div>
                                                                </div>

                                                                <div className="col-md-6 col-lg-4 col-xl-3">
                                                                    <div className="form-group">
                                                                        <label htmlFor="medical_scheme_code">Medical Scheme Name
                                                                        <span className="mandatory">*</span>
                                                                        </label>

                                                                        <Field
                                                                            as="select"
                                                                            name="medical_scheme_code"
                                                                            disabled={true}
                                                                            placeholder="Medical Scheme Name"
                                                                            className={
                                                                                "form-control" +
                                                                                (errors.medical_scheme_code && touched.medical_scheme_code
                                                                                    ? " is-invalid"
                                                                                    : "")
                                                                            }
                                                                            onChange={this.handleInputChange}

                                                                        >
                                                                            <option value="">Select Scheme</option>
                                                                            {mediaclAidSchemeOptions}
                                                                        </Field>
                                                                        {/* <Select
                                                                    showSearch
                                                                    allowClear={true}
                                                                    name="medical_scheme_code"
                                                                    placeholder="Search Scheme"
                                                                    optionFilterProp="children"
                                                                    className={
                                                                        (errors.medical_scheme_code && touched.medical_scheme_code
                                                                            ? "form-control is-invalid"
                                                                            : "")
                                                                    }
                                                                    onChange={this.onChangeSchemePlan}
                                                                    filterOption={(input, option) =>
                                                                        option.children
                                                                        .toLowerCase()
                                                                        .indexOf(input.toLowerCase()) >= 0
                                                                    }
                                                                    value={this.state.medical_scheme_code || undefined}
                                                                    >
                                                                    {schemesDropDownListData &&
                                                                        schemesDropDownListData.map((element, index) => (
                                                                        <Option key={index} title={`${element.name} (${element.code})`} value={element.code}>
                                                                           {element.name} ({element.code})
                                                                        </Option>
                                                                        ))}
                                                                    </Select> */}
                                                                        <ErrorMessage
                                                                            name="medical_scheme_code"
                                                                            component="div"
                                                                            className="invalid-feedback"
                                                                        />
                                                                    </div>
                                                                </div>



                                                                <div className="col-md-6 col-lg-4 col-xl-3">
                                                                    <div className="form-group">
                                                                        <label htmlFor="medical_scheme_plan">Medical Scheme Plan
                                                                        <span className="mandatory">*</span>
                                                                        </label>

                                                                        <Field
                                                                            as="select"
                                                                            name="medical_scheme_plan"
                                                                            onChange={this.handleInputChange}
                                                                            disabled={true}
                                                                            //disabled={!this.state.medical_scheme_code}
                                                                            className={
                                                                                "form-control" +
                                                                                (errors.medical_scheme_plan && touched.medical_scheme_plan
                                                                                    ? " is-invalid"
                                                                                    : "")
                                                                            }
                                                                        >
                                                                            <option value="">Select Scheme Plan</option>
                                                                            {mediaclAidSchemePlanOptions}
                                                                        </Field>
                                                                        {/* <Select
                                                                    showSearch
                                                                    allowClear={true}
                                                                    name="medical_scheme_plan"
                                                                    placeholder="Search Scheme Plan"
                                                                    optionFilterProp="children"
                                                                    className={
                                                                        (errors.medical_scheme_plan && touched.medical_scheme_plan
                                                                            ? "form-control is-invalid"
                                                                            : "")
                                                                    }
                                                                    onChange={this.onChangeSchemePlan}
                                                                    filterOption={(input, option) =>
                                                                        option.children
                                                                        .toLowerCase()
                                                                        .indexOf(input.toLowerCase()) >= 0
                                                                    }
                                                                    value={this.state.medical_scheme_plan || undefined}
                                                                    >
                                                                     {patientOptions &&
                                                                        patientOptions.map((element, index) => (
                                                                        <Option key={index} value={element.patient_id}>
                                                                            {element.patient_name}
                                                                        </Option>
                                                                        ))} 
                                                                    </Select> */}
                                                                        <ErrorMessage
                                                                            name="medical_scheme_plan"
                                                                            component="div"
                                                                            className="invalid-feedback"
                                                                        />
                                                                    </div>
                                                                </div>
                                                                {mediaclAidSchemePlanOptions &&
                                                                    mediaclAidSchemePlanOptions.length > 0 &&
                                                                    mediaclAidSchemePlanOptionsOptions &&
                                                                    mediaclAidSchemePlanOptionsOptions.length > 0 &&
                                                                    (
                                                                        <div className="col-md-6 col-lg-4 col-xl-3">
                                                                            <div className="form-group">
                                                                                <label htmlFor="medical_scheme_plan_option">Medical Scheme Plan Option
                                                                        <span className="mandatory">*</span>
                                                                                </label>
                                                                                <Field
                                                                                    as="select"
                                                                                    name="medical_scheme_plan_option"
                                                                                    onChange={this.handleInputChange}
                                                                                    disabled={true}
                                                                                    //disabled={!this.state.medical_scheme_plan}
                                                                                    className={
                                                                                        "form-control" +
                                                                                        (errors.medical_scheme_plan_option && touched.medical_scheme_plan_option
                                                                                            ? " is-invalid"
                                                                                            : "")
                                                                                    }
                                                                                >
                                                                                    <option value="">Select Scheme Plan Option</option>
                                                                                    {mediaclAidSchemePlanOptionsOptions}
                                                                                </Field>
                                                                                <ErrorMessage
                                                                                    name="medical_scheme_plan_option"
                                                                                    component="div"
                                                                                    className="invalid-feedback"
                                                                                />
                                                                            </div>
                                                                        </div>)}
                                                                {mediaclAidSchemePlanOptions &&
                                                                    mediaclAidSchemePlanOptions.length > 0 &&
                                                                    mediaclAidSchemePlanOptionsOptions &&
                                                                    mediaclAidSchemePlanOptionsOptions.length > 0 &&
                                                                    mediaclAidSchemePlanSubOptionsOptions &&
                                                                    mediaclAidSchemePlanSubOptionsOptions.length > 0 && (

                                                                        <div className="col-md-6 col-lg-4 col-xl-3">
                                                                            <div className="form-group">
                                                                                <label htmlFor="medical_scheme_plan_suboption">Medical Scheme Plan Option
                                                                        <span className="mandatory">*</span>
                                                                                </label>
                                                                                <Field
                                                                                    as="select"
                                                                                    name="medical_scheme_plan_suboption"
                                                                                    disabled={true}
                                                                                    //disabled={!this.state.medical_scheme_plan_option}
                                                                                    onChange={this.handleInputChange}
                                                                                    className={
                                                                                        "form-control" +
                                                                                        (errors.medical_scheme_plan_suboption && touched.medical_scheme_plan_suboption
                                                                                            ? " is-invalid"
                                                                                            : "")
                                                                                    }
                                                                                >
                                                                                    <option value="">Select Scheme Plan Sub Option</option>
                                                                                    {mediaclAidSchemePlanSubOptionsOptions}
                                                                                </Field>
                                                                                <ErrorMessage
                                                                                    name="medical_scheme_plan_suboption"
                                                                                    component="div"
                                                                                    className="invalid-feedback"
                                                                                />
                                                                            </div>
                                                                        </div>)}
                                                                <div className="col-md-6 col-lg-4 col-xl-3">
                                                                    <div className="form-group">
                                                                        <label htmlFor="membership_number">Membership Number
                                                                        <span className="mandatory">*</span>
                                                                        </label>

                                                                        <Field
                                                                            name="membership_number"
                                                                            type="text"
                                                                            maxLength="20"
                                                                            placeholder="Membership Number"
                                                                            disabled={true}
                                                                            className={
                                                                                "form-control" +
                                                                                (errors.membership_number && touched.membership_number
                                                                                    ? " is-invalid"
                                                                                    : "")
                                                                            }
                                                                            onChange={this.handleInputChange}
                                                                        />
                                                                        <ErrorMessage
                                                                            name="membership_number"
                                                                            component="div"
                                                                            className="invalid-feedback"
                                                                        />
                                                                    </div>
                                                                </div>

                                                                <div className="col-md-6 col-lg-4 col-xl-3">
                                                                    <div className="form-group">
                                                                        <label htmlFor="memberIDPassportNumber">ID/Passport Number
                                                                        <span className="mandatory">*</span>
                                                                        </label>

                                                                        <Field
                                                                            name="memberIDPassportNumber"
                                                                            type="text"
                                                                            placeholder="ID/Passport Number"
                                                                            maxLength="20"
                                                                            className={
                                                                                "form-control" +
                                                                                (errors.memberIDPassportNumber && touched.memberIDPassportNumber
                                                                                    ? " is-invalid"
                                                                                    : "")
                                                                            }
                                                                            onChange={this.handleInputChange}
                                                                        />
                                                                        <ErrorMessage
                                                                            name="memberIDPassportNumber"
                                                                            component="div"
                                                                            className="invalid-feedback"
                                                                        />
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>


                                                        <div className="form-box-shadow mt-4">
                                                            <div className="row">
                                                                <div className="col-lg-12">
                                                                    <h5>Patient Information</h5>
                                                                </div>
                                                            </div>

                                                            <div className="row">
                                                                <div className="col-md-6 col-lg-4 col-xl-3">
                                                                    <div className="form-group">
                                                                        <label htmlFor="patient_full_name">Patient Full Name
                                                                        <span className="mandatory">*</span>
                                                                        </label>

                                                                        <Field
                                                                            name="patient_full_name"
                                                                            type="text"
                                                                            maxLength="30"
                                                                            placeholder="Patient Full Name"
                                                                            className={
                                                                                "form-control" +
                                                                                (errors.patient_full_name && touched.patient_full_name
                                                                                    ? " is-invalid"
                                                                                    : "")
                                                                            }
                                                                            onChange={this.handleInputChange}
                                                                        />
                                                                        <ErrorMessage
                                                                            name="patient_full_name"
                                                                            component="div"
                                                                            className="invalid-feedback"
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6 col-lg-4 col-xl-3">
                                                                    <div className="form-group">
                                                                        <label htmlFor="patient_surname">Patient Surname
                                                                        <span className="mandatory">*</span>
                                                                        </label>

                                                                        <Field
                                                                            name="patient_surname"
                                                                            type="text"
                                                                            maxLength="30"
                                                                            placeholder="Patient Surname"
                                                                            className={
                                                                                "form-control" +
                                                                                (errors.patient_surname && touched.patient_surname
                                                                                    ? " is-invalid"
                                                                                    : "")
                                                                            }
                                                                            onChange={this.handleInputChange}
                                                                        />
                                                                        <ErrorMessage
                                                                            name="patient_surname"
                                                                            component="div"
                                                                            className="invalid-feedback"
                                                                        />
                                                                    </div>
                                                                </div>

                                                                <div className="col-md-6 col-lg-4 col-xl-3">
                                                                    <div className="form-group">
                                                                        <label htmlFor="patient_initials">Patient Initials
                                                                        <span className="mandatory">*</span>
                                                                        </label>

                                                                        <Field
                                                                            type="text"
                                                                            name="patient_initials"
                                                                            placeholder="Patient Initials"
                                                                            maxLength="5"
                                                                            className={
                                                                                "form-control" +
                                                                                (errors.patient_initials && touched.patient_initials
                                                                                    ? " is-invalid"
                                                                                    : "")
                                                                            }
                                                                            onChange={this.handleInputChange}

                                                                        >
                                                                        </Field>
                                                                        <ErrorMessage
                                                                            name="patient_initials"
                                                                            component="div"
                                                                            className="invalid-feedback"
                                                                        />
                                                                    </div>
                                                                </div>

                                                                <div className="col-md-6 col-lg-4 col-xl-3">
                                                                    <div className="form-group">
                                                                        <label htmlFor="dateOfBirth">Date Of Birth
                                                                        <span className="mandatory">*</span>
                                                                        </label>
                                                                        <DatePicker
                                                                            onChange={(date, dateString) => {
                                                                                this.handleInputDateChange(dateString);
                                                                            }}
                                                                            placeholder="Date of Birth"
                                                                            className={
                                                                                "form-control" +
                                                                                (errors.dateOfBirth && touched.dateOfBirth
                                                                                    ? " is-invalid"
                                                                                    : "")
                                                                            }
                                                                            format="YYYY-MM-DD"
                                                                            value={this.state.dateOfBirth ? moment(this.state.dateOfBirth) : ""}
                                                                        />
                                                                        <ErrorMessage
                                                                            name="dateOfBirth"
                                                                            component="div"
                                                                            className="invalid-feedback"
                                                                        />
                                                                    </div>
                                                                </div>

                                                                <div className="col-md-6 col-lg-4 col-xl-3">
                                                                    <div className="form-group">
                                                                        <label htmlFor="gender">Gender
                                                                        <span className="mandatory">*</span>
                                                                        </label>

                                                                        <Field
                                                                            as="select"
                                                                            name="gender"
                                                                            placeholder="Gender"
                                                                            onChange={this.handleInputChange}
                                                                            className={
                                                                                "form-control" +
                                                                                (errors.gender && touched.gender
                                                                                    ? " is-invalid"
                                                                                    : "")
                                                                            }
                                                                        >
                                                                            <option value="">Select Gender</option>
                                                                            <option value="Male">Male</option>
                                                                            <option value="Female">Female</option>
                                                                        </Field>
                                                                        <ErrorMessage
                                                                            name="gender"
                                                                            component="div"
                                                                            className="invalid-feedback"
                                                                        />
                                                                    </div>
                                                                </div>

                                                                <div className="col-md-6 col-lg-4 col-xl-3">
                                                                    <div className="form-group">
                                                                        <label htmlFor="patient_height">Patient Height (in cm)</label>
                                                                        <Field
                                                                            type="text"
                                                                            name="patient_height"
                                                                            maxLength="3"
                                                                            placeholder="Height (Rounded off manner)"
                                                                            onChange={this.handleInputChange}
                                                                            className={
                                                                                "form-control" +
                                                                                (errors.patient_height && touched.patient_height
                                                                                    ? " is-invalid"
                                                                                    : "")
                                                                            }
                                                                        >
                                                                        </Field>
                                                                        <ErrorMessage
                                                                            name="patient_height"
                                                                            component="div"
                                                                            className="invalid-feedback"
                                                                        />
                                                                    </div>
                                                                </div>

                                                                <div className="col-md-6 col-lg-4 col-xl-3">
                                                                    <div className="form-group">
                                                                        <label htmlFor="patient_weight">Patient Weight (in gms)</label>

                                                                        <Field
                                                                            name="patient_weight"
                                                                            type="text"
                                                                            maxLength="6"
                                                                            placeholder="Weight (Rounded off manner)"
                                                                            className={
                                                                                "form-control" +
                                                                                (errors.patient_weight && touched.patient_weight
                                                                                    ? " is-invalid"
                                                                                    : "")
                                                                            }
                                                                            onChange={this.handleInputChange}
                                                                        />
                                                                        <ErrorMessage
                                                                            name="patient_weight"
                                                                            component="div"
                                                                            className="invalid-feedback"
                                                                        />
                                                                    </div>
                                                                </div>

                                                                <div className="col-md-6 col-lg-4 col-xl-3">
                                                                    <div className="form-group">
                                                                        <label htmlFor="patientIDPassportNumber">ID/Passport Number
                                                                        <span className="mandatory">*</span>
                                                                        </label>

                                                                        <Field
                                                                            name="patientIDPassportNumber"
                                                                            type="text"
                                                                            maxLength="20"
                                                                            placeholder="ID/Passport Number"
                                                                            className={
                                                                                "form-control" +
                                                                                (errors.patientIDPassportNumber && touched.patientIDPassportNumber
                                                                                    ? " is-invalid"
                                                                                    : "")
                                                                            }
                                                                            onChange={this.handleInputChange}
                                                                        />
                                                                        <ErrorMessage
                                                                            name="patientIDPassportNumber"
                                                                            component="div"
                                                                            className="invalid-feedback"
                                                                        />
                                                                    </div>
                                                                </div>

                                                                <div className="col-md-6 col-lg-4 col-xl-3">
                                                                    <div className="form-group">
                                                                        <label htmlFor="dependent_code">Dependent Code
                                                                        <span className="mandatory">*</span>
                                                                        </label>

                                                                        <Field
                                                                            name="dependent_code"
                                                                            type="text"
                                                                            maxLength="3"
                                                                            placeholder="Dependent Code"
                                                                            className={
                                                                                "form-control" +
                                                                                (errors.dependent_code && touched.dependent_code
                                                                                    ? " is-invalid"
                                                                                    : "")
                                                                            }
                                                                            onChange={this.handleInputChange}
                                                                        />
                                                                        <ErrorMessage
                                                                            name="dependent_code"
                                                                            component="div"
                                                                            className="invalid-feedback"
                                                                        />
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>
                                                        <div className="row ">
                                                            <div className="col-md-12">
                                                                {this.state.submitClaimLoader && (
                                                                        <div className={`error ${style.loadingWrapper}`}>
                                                                            <img src={ttmLoader} alt="loader" className={style.loading} />
                                                                        </div>
                                                                    )}
                                                                {!this.state.submitClaimLoader &&
                                                                    this.state.successMessage && (
                                                                        <div>
                                                                            <p className={style.successMessage}>{this.state.successMessage}</p>
                                                                        </div>)}
                                                                {!this.state.submitClaimLoader &&
                                                                    this.state.errorMessage && (<div>
                                                                        <p className={style.errorMessage}>{this.state.errorMessage}</p>
                                                                    </div>
                                                                    )}
                                                            </div>
                                                        </div>
                                                        <div className={`row ${style.mediclaimProcessBtnWrapper}`}>
                                                            <div className="col-md-12">
                                                                <div>
                                                                    <Button
                                                                        className="ttm-primary-btn"
                                                                        type="submit"
                                                                        disabled={this.state.submitClaimLoader}
                                                                    // onClick={this.onSubmit}
                                                                    >
                                                                        Submit Claim
                                                                    </Button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Form>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}

                        </Formik>
                    </div>
                </div>
            </div>


        );
    }
}

const mapStateToProps = (state) => {
    return {
        patientData: state.relatedPartyData,
        schemesData: state.schemes,
        schemesPlanData: state.schemesPlan,
        schemesPlanOptionsData: state.schemesPlanOptions,
        schemesPlanSubOptionsData: state.schemesPlanSubOptions,
        submitClaimData: state.claimSubmitResponse,
        linkDestinationCodeData: state.linkDestinationCodes,
        checkMSVDetailsData: state.checkMSVDetails
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        submitClaim: (payload) => dispatch(submitClaim(payload)),
        checkMSVDetails: (patient_id, practitioner_id) => dispatch(checkMSVDetails(patient_id, practitioner_id)),
        linkDestinationCodes: (contact_id) => dispatch(linkDestinationCodes(contact_id)),
        fetchRelatedParty: (value) => dispatch(fetchRelatedParty(value)),
        fetchMedSchemes: (scheme) => dispatch(fetchMedSchemes(scheme)),
        fetchMedSchemesPlan: (scheme_code) => dispatch(fetchMedSchemesPlan(scheme_code)),
        fetchMedSchemesPlanOptions: (plan_code) => dispatch(fetchMedSchemesPlanOptions(plan_code)),
        fetchMedSchemesPlanSubOptions: (plan_option_code) => dispatch(fetchMedSchemesPlanSubOptions(plan_option_code)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(MediclaimProcess);
